/**
 * Texte der Verwaltungsbereiche „Konten“, „Kostenstellen“, „Vertragsarten“ und der Ergänzungen in Verwaltung › DATEV
 * (Plan „Rollen am Geschäftspartner und Lieferantenverträge“, Aufgabe 9; P5: eine Tabelle je Strang, englische
 * Schlüssel, kein Text im JSX). Die Wertelisten der Vertragsarten folgen der Spec („Vertragsarten“, „Abrechnungsweise“).
 */
import { SUPPLIER_TEXT_WEB } from "../../suppliers/texts.js";

export const ACCOUNTS_TEXT = {
  accounts: "Konten",
  costCentres: "Kostenstellen",
  contractTypes: "Vertragsarten",
  groupChart: (chart: string): string => `Kontenrahmen ${chart}`,
  revenue: "Erlös",
  expense: "Aufwand",
  inactive: "deaktiviert",
  inUse: "verwendet",
  newAccount: "Neues Konto",
  newCostCentre: "Neue Kostenstelle",
  creditorRange: "Kreditorenkreis",
  creditorRangeFrom: "Kreditorenkreis von",
  creditorRangeTo: "Kreditorenkreis bis",
  notInExtract: "Konto nicht im SKR04-Auszug",
  // Ohne Anführungszeichen, die Art vor dem Namen — die Mehrheitsform der Fragen im Bestand (Hausregel „durchgängig
  // einheitlich“, wie „Dateityp ‹Name› stilllegen?“).
  confirmDeactivate: (art: string | undefined, name: string): string =>
    `${art === undefined ? "" : `${art} `}${name} deaktivieren?`,
  accountKind: "Konto",
  costCentreKind: "Kostenstelle",
  contractTypeKind: "Vertragsart",
  deactivateConsequence: "Der Eintrag steht danach in keiner Auswahl mehr; vorhandene Kontierungen bleiben.",
  deactivate: "Deaktivieren",
  editAccount: "Konto ändern",
  editCostCentre: "Kostenstelle ändern",
  editContractType: "Vertragsart ändern",
  edit: "Ändern",
  editNamed: (name: string): string => `${name} ändern`,
  save: "Speichern",
  cancel: "Abbrechen",
  loading: "Lädt …",
  loadFailed: "Die Liste konnte nicht geladen werden.",
  chart: "Kontenrahmen",
  accountNumber: "Nummer",
  name: "Bezeichnung",
  kind: "Art",
  state: "Zustand",
  active: "aktiv",
  code: "Kürzel",
  billingMode: "Abrechnungsweise",
  cycle: "Rhythmus",
  paymentMethod: "Zahlweise",
  defaultAccount: (chart: string): string => `Vorgabekonto ${chart}`,
  none: "–",
  pending: "…",
  // Abrechnungsweisen, Rhythmen und Zahlweisen stehen EINMAL in den Texten der Lieferverträge (Final-Fixrunde A-K3).
  billingModes: SUPPLIER_TEXT_WEB.billingMode,
  cycles: SUPPLIER_TEXT_WEB.cycles,
  paymentMethods: SUPPLIER_TEXT_WEB.paymentMethod,
} as const;
